import { IDocumentTemplate } from 'interfaces/documentation/document-template';
import { SectionSentDocuments } from './SectionSentDocuments';
import { SectionUserInfo } from './SectionUserInfo';
import { useCertificateStore } from '../../../certificate.store';
import { useList } from '@refinedev/core';
import { useState } from 'react';

export const TabUserInfo = () => {
  const { enrollment } = useCertificateStore();
  const { user } = enrollment!;
  const [isEditing, setIsEditing] = useState(false);

  const { data: documentTemplates } = useList<IDocumentTemplate>({
    resource: 'documents/templates',

    filters: [
      {
        field: 'filter[by_course_id]',
        operator: 'eq',
        value: enrollment?.course?.id
      }
    ]
  });

  return (
    <>
      <SectionUserInfo
        user={user}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />

      <SectionSentDocuments templates={documentTemplates?.data ?? []} />
    </>
  );
};
